
import React, { Component}  from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import _ from 'lodash';

import { grey } from "@material-ui/core/colors";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { FormContext } from 'core/FormProvider';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';

import { AsyncAutocompleteWidget } from "form/AutocompleteWidget";
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { OrderPointServicesForm } from './PointServicesForm';
import { DateTimeWidget } from 'form/new/DateTimeWidget';
import { Grid } from 'ui/Grid';
import { AddPointDialog } from './AddPointDialog.js';
import {AsyncAutocompleteWidget2} from "form/AutocompleteWidget2";
import {EditPointDialog} from "./EditPointDialog";

const StyledPointsOrderForm = styled.div`
  max-width: 1200px;
  margin-bottom: 40px;
`;


const StyledFormOrderPoint = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-row-gap: 15px;
  grid-template-columns: 24px 1fr;
  margin-bottom: 20px;
  
  .wrapper {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 150px 30px;
    grid-gap: 10px;
    grid-row-gap: 15px;
  }
`;

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
  margin-top: 15px;
`;

const ChangePositionButton = styled(IconButton)`
  padding: 0 !important;
  font-size: 1rem;
  margin-top: 5px;
  color: ${grey[300]};
  
  &:hover {
    color: ${grey[600]};
  }
`;


class PointOrderForm extends Component {

  constructor(props) {
    super(props);

    const orderPoint = props.context.getValue(this.getFieldPath());

    this.state = {
      isDrawerOpen: false,
      isShowDateField: orderPoint.date !== null
    };
  }

  toggleDrawer = () => {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
    })
  };

  getFieldPath = () => {
    const { pointIndex } = this.props;
    return `points.${pointIndex}`;
  };

  handlePointChange = (context, value) => {
    const fieldPath = this.getFieldPath();
    context.setValue(`${fieldPath}.point`, value);
    if (value) {
      context.setValue(`${fieldPath}.point_address`, value.address);
      context.setValue(`${fieldPath}.point_contact`, value.contact);
      context.setValue(`${fieldPath}.point_text`, value.description);
    }
    else {
      context.setValue(`${fieldPath}.point_address`, '');
      context.setValue(`${fieldPath}.point_contact`, '');
    }
  };

  showDateField = () => {
    this.setState({
      isShowDateField: true
    })
  };

  hideDateField = () => {
    const { context } = this.props;
    const fieldPath = this.getFieldPath();
    context.setValue(`${fieldPath}.date`, null);
    this.setState({
      isShowDateField: false
    });
  };

  render() {
    const { context, number, pointIndex, activePointIndex, onDelete, onChangePosition, isFirst, isLast, showPointExtraFields } = this.props;
    const { isShowDateField } = this.state;
    const order = context.item;
    const fieldPath = this.getFieldPath();
    const pointValue = context.getValue(`${fieldPath}.point`);
    const orderPoint = context.getValue(fieldPath);

    return (
      <StyledFormOrderPoint>
        <div>
          <Index>{number}</Index>
          {!isFirst && (
            <ChangePositionButton
              variant="outlined"
              size={'small'}
              onClick={() => onChangePosition(context, activePointIndex, 'up')}
            >
              <ArrowUpwardIcon />
            </ChangePositionButton>
          )}
          {!isLast && (
            <ChangePositionButton
              variant="outlined"
              size={'small'}
              onClick={() => onChangePosition(context, activePointIndex, 'down')}
            >
              <ArrowDownwardIcon />
            </ChangePositionButton>
          )}
        </div>

        <div className={'wrapper'}>
          <div>
            <ContextFormControlWidget
              name={`${fieldPath}.point`}
              WidgetComponent={AsyncAutocompleteWidget2}
              widgetProps={{
                label: 'Точка',
                url: 'catalog/point',
                filter: {
                  client: order.client ? order.client.id : null,
                  page_size: 50
                },
                optionLabel: 'name',
                onChange: (valueId, value) => this.handlePointChange(context, value),
                dialogTitle: 'Новая точка',
                DialogComponent: AddPointDialog,
                EditDialogComponent: EditPointDialog,
                disableClearable: true,
                dialogProps: {
                  fullWidth: true,
                  maxWidth: 'md'
                }
              }}
            />
          </div>
          <div>
            <ContextWidget
              name={`${fieldPath}.point_address`}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Адрес',
                multiline: true,
                InputLabelProps: {
                  shrink: true
                }
              }}
            />
          </div>
          <div>
            <ContextWidget
              name={`${fieldPath}.point_contact`}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Контактная информация',
                multiline: true,
                InputLabelProps: {
                  shrink: true
                }
              }}
            />
          </div>
          <div className={'pt-0'}>
            {pointValue && (
              <OrderPointServicesForm
                pointIndex={pointIndex}
                context={context}
                orderPoint={orderPoint}
              />
            )}
            {!pointValue && (
              <Button
                disabled={true}
                variant="outlined"
                size={'small'}
                fullWidth={true}
              >
                + Услуги
              </Button>
            )}
          </div>
          <div className={'pt-0'}>
            <IconButton size="small" onClick={() => onDelete(context, pointIndex)}>
              <ClearIcon />
            </IconButton>
          </div>
          {showPointExtraFields && (
            <>
              <div>
                <ContextFormControlWidget
                  WidgetComponent={AsyncAutocompleteWidget}
                  name={`${fieldPath}.status`}
                  size={'small'}
                  widgetProps={{
                    url: 'catalog/choice',
                    size: 'small',
                    label: 'Статус',
                    filter: {
                      type: 'ORDER_POINT_STATUS'
                    }
                  }}
                />
              </div>
              <div>
                <ContextWidget
                  name={`${fieldPath}.point_text`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Описание точки',
                    size: 'small',
                    multiline: true,
                    InputLabelProps: {
                      shrink: true
                    }
                  }}
                />
              </div>
              <div/>
              <div/>
              <div/>
              <div>
                {!isShowDateField && (
                  <Button
                    size={'small'}
                    variant={'outlined'}
                    onClick={() => this.showDateField()}>
                    + Дата подачи
                  </Button>
                )}

                {isShowDateField && (
                  <Grid columns={'1fr 30px'}>
                    <div>
                      <DateTimeWidget
                        value={context.getValue(`${fieldPath}.date`)}
                        label={'Дата подачи'}
                        size={'small'}
                        onChange={(value, stringValue) => context.setDateTimeValue(`${fieldPath}.date`, value)}
                      />
                    </div>
                    <div className={'pt-5'}>
                      <IconButton size="small" onClick={() => this.hideDateField()}>
                        <ClearIcon />
                      </IconButton>
                    </div>
                  </Grid>
                )}
              </div>
            </>
          )}
        </div>
      </StyledFormOrderPoint>
    )
  }
}


export default class PointsOrderForm extends Component {

  static defaultProps = {
    showPointExtraFields: true,
    PointComponent: PointOrderForm
  }

  addPoint = (context) => {
    let points = context.item.points;
    points.push({
      date: null,
      services: [],
      is_delete: false,
      position: points.length + 1
    });
    context.setValue('points', points);
  };

  handleDeletePoint = (context, index) => {
    if (index !== -1) {
      let point = context.item.points[index];
      if (point.id) {
        const index = _.findIndex(context.item.points, {id: point.id});
        context.setValue(this.getFieldPath(index, 'is_delete'), true);
      }
      else {
        context.removeArrayValue(`points`, index);
      }
    }
  };

  getFieldPath = (index, name) => {
    return `points.${index}.${name}`;
  };

  handleChangePosition = (context, index, variant) => {
    let points = context.item.points;
    points.forEach((point, index) => point['position'] = index + 1);
    let activePoints = _.reject(points, {is_delete: true});
    const oldPosition = activePoints[index].position;
    if (variant === 'up' && activePoints[index - 1]) {
      activePoints[index].position = activePoints[index - 1].position;
      activePoints[index - 1].position = oldPosition;
    }
    else if (variant === 'down' && activePoints[index + 1]) {
      activePoints[index].position = activePoints[index + 1].position;
      activePoints[index + 1].position = oldPosition;
    }

    points = _.sortBy(points, ['position']);
    context.setValue('points', points);
  };

  render() {
    const { PointComponent, showPointExtraFields } = this.props;
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;
          const { points } = item;
          let number = 1;
          let activePointIndex = 0;
          const activePoints = _.reject(points, {is_delete: true});
          const firstActivePoint = _.head(activePoints);
          const lastActivePoint = _.last(activePoints);

          return (
            <StyledPointsOrderForm>
              <h3>Маршрут {activePoints.length}</h3>

              {points.map((item, index) =>
                <React.Fragment key={index}>
                  {!item.is_delete && (
                    <PointComponent
                      isFirst={item === firstActivePoint}
                      isLast={item === lastActivePoint}
                      pointIndex={index}
                      activePointIndex={activePointIndex++}
                      number={number++}
                      item={item}
                      context={context}
                      onDelete={this.handleDeletePoint}
                      onChangePosition={this.handleChangePosition}
                      showPointExtraFields={showPointExtraFields}
                    />
                  )}
                </React.Fragment>
              )}

              <div>
                <Button
                  variant="outlined"
                  onClick={() => this.addPoint(context)}
                >
                  + Добавить пункт
                </Button>
              </div>
            </StyledPointsOrderForm>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
